import { useState } from 'react';
import './Expander.css';

const Expander = ({ data }) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  if (!data || !data.expander) {
    return (
      <div className="about-terawalis">
        <div className="main-content">
          <h1 className="main-title">No Data Available</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="about-terawalis">
      <div className="main-content">
        <h1 className="main-title">{data.title || "Title"}</h1>
      </div>

      <div className="expander-section">
        <div className="expander-list">
          {data.expander.map((item, index) => (
            <div key={item.id || index} className="expander-item">
              <button
                className={`expander-header ${expandedItems[item.id] ? 'expanded' : ''}`}
                onClick={() => toggleExpand(item.id)}
              >
                <span className="header-text">{item.header}</span>
                <span className="expand-icon">
                  {expandedItems[item.id] ? '×' : '+'}
                </span>
              </button>
              
              {expandedItems[item.id] && item.subtext && (
                <div className="expander-content">
                  <p className="expander-text">{item.subtext}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Expander;